import { Pipe, PipeTransform } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HandoffType } from '../interfaces/handoff-type.enum';
import { GlobalStateModel } from '../store/state.model';

@Pipe({
  name: 'handoffLabel',
  pure: false, // impure pipe since we're working with observables
})
export class HandoffLabelPipe implements PipeTransform {
  @Select((state: GlobalStateModel) => state.order.brandHandoffs)
  brandHandoffs$!: Observable<{ handoff: HandoffType; label: string }[]>;

  /**
   * Transform a handoff type to its corresponding label
   * @param handoffType The handoff type to look up
   * @param defaultLabel Optional default label if no match is found (defaults to handoff type name)
   * @returns Observable with the handoff label
   */
  transform(handoffType: HandoffType, defaultLabel?: string): Observable<string> {
    if (handoffType === undefined || handoffType === null) {
      return of(defaultLabel || '');
    }
    
    // Default labels for each handoff type if not provided
    const defaultLabels = {
      [HandoffType.pickup]: 'Pickup',
      [HandoffType.curbside]: 'Curbside',
      [HandoffType.delivery]: 'Delivery',
      [HandoffType.dispatch]: 'Delivery',
      [HandoffType.driveThru]: 'Drive-Thru',
      [HandoffType.dineIn]: 'Dine-In',
      [HandoffType.loading]: 'Loading',
    };

    // Get the appropriate fallback label
    const fallback = defaultLabel || defaultLabels[handoffType] || `Handoff ${handoffType}`;

    return this.brandHandoffs$.pipe(
      map(handoffs => {
        if (!handoffs || handoffs.length === 0) {
          return fallback;
        }
        
        const handoff = handoffs.find(h => h.handoff === handoffType);
        return handoff ? handoff.label : fallback;
      }),
    );
  }
} 